import { Component, OnInit } from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AccountInfoService} from '../../user/account-info.service';
import {interval} from 'rxjs';
import {Router} from '@angular/router';
import {EmailtemplateService} from '../../emailtemplate.service';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';

@Component({
  selector: 'app-businessdetails',
  templateUrl: './businessdetails.component.html',
  styleUrls: ['./businessdetails.component.scss']
})
export class BusinessdetailsComponent implements OnInit {

  constructor(public settingComp: SettingsComponent,
              private appComp: AppComponent,
              public accountInfoService: AccountInfoService,
              public platform: LeftpanelComponent,
              public router: Router,
              private adminEnvironmenthandler: AdminEnvironmentHandlerService,
              private partnerSettingsService: PartnerSettingsService) { }
  tempData: any;
  partner: any;
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  regexp1 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
  regexp2 = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);

  redirect(route: string) {
    this.router.navigate([route]);
  }

  initialize() {
    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        let environmentData = this.partnerSettingsService.environment;
        if (!environmentData.name.includes('admin')) {
          this.redirect('/console');
        } else {
          this.setData();
        }
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          environmentData = this.partnerSettingsService.environment;
          if (!environmentData.name.includes('admin')) {
            this.redirect('/console');
          } else {
            this.setData();
          }
        });
      }
    }));
  }

  setData() {
    this.partner = localStorage.getItem('partner');
    this.appComp.currentPageTitle = 'Manage Organization Details';
    this.appComp.ribbon = 'Business Details';
    if (!this.settingComp.item) {
      Promise.resolve(this.settingComp.setcolumnvalues()).then(response => {
        if (response === 'success') {
          this.tempData = JSON.parse(JSON.stringify(this.settingComp.item));
        } else {
        }
      });
    } else {
      this.tempData = JSON.parse(JSON.stringify(this.settingComp.item));
    }
  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.initialize();
  }

  checkGST(gst) {
      return /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[Zz]{1}[0-9A-Za-z]{1}$/.test(gst);
  }

  checkPAN(pan) {
    return /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(pan);
  }

  checkEmail(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
  }

  checkPhoneNumber(phoneNumber) {
    return /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phoneNumber);
  }

  sendPartner() {
    if (this.settingComp.item['secondary_email'] !== this.tempData['secondary_email'] || this.settingComp.item['secondary_phone'] !== this.tempData['secondary_phone'] || this.settingComp.item['GST'] !== this.tempData['GST'] || this.settingComp.item['PAN'] !== this.tempData['PAN'] || this.settingComp.item['partner_organisation'] !== this.tempData['partner_organisation'] || this.settingComp.item['partner_organisation_type'] !== this.tempData['partner_organisation_type']) {
      if ((this.settingComp.item['secondary_email'] === '' || this.settingComp.item['secondary_email'] === undefined || this.checkEmail(this.settingComp.item['secondary_email'])) && (this.settingComp.item['secondary_phone'] === '' || this.settingComp.item['secondary_phone'] === undefined || this.checkPhoneNumber(this.settingComp.item['secondary_phone'])) && (this.settingComp.item['GST'] === '' || this.settingComp.item['GST'] === undefined || this.checkGST(this.settingComp.item['GST'])) && (this.settingComp.item['PAN'] === '' || this.settingComp.item['PAN'] === undefined || this.checkPAN(this.settingComp.item['PAN']))) {
        this.settingComp.sendPartnerData();
      } else {
        if (this.settingComp.item['secondary_email'] !== '' && this.settingComp.item['secondary_email'] !== undefined && !this.checkEmail(this.settingComp.item['secondary_email'])) {
          this.platform.openSnackBar('Enter a valid Secondary Email', 'Error', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        } else if (!this.checkPhoneNumber(this.settingComp.item['secondary_phone']) && this.settingComp.item['secondary_phone'] !== '' && this.settingComp.item['secondary_phone'] !== undefined) {
          this.platform.openSnackBar('Enter a valid Secondary Phone', 'Error', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        } else if (!this.checkPAN(this.settingComp.item['PAN']) && this.settingComp.item['PAN'] !== '' && this.settingComp.item['PAN'] !== undefined) {
          this.platform.openSnackBar('Enter a valid PAN number', 'Error', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        } else if (!this.checkGST(this.settingComp.item['GST']) && this.settingComp.item['GST'] !== '' && this.settingComp.item['GST'] !== undefined) {
          this.platform.openSnackBar('Enter a valid GST number', 'Error', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        } else {
          this.platform.openSnackBar('Enter valid details', 'Error', {
            duration: 1500,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    } else {
      this.platform.openSnackBar('There is no new information to update', 'Info', {
        duration: 1500,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }
}
